import Config from "../../config";

/**
 * Helper method for generating links
 *
 * This method performs various operations on the URL such as attaching analytics variables and whatnot
 *
 * @param {String} url The URL to link to
 * @param params
 */
export function link(url, params = {}) {
    try {
        let _url = new URL(url);

        // Get the global HTTP parameters for the site
        let final = Object.assign({}, Config.urls.globalParams);

        // Loop over the user's params and push them to the final array
        for (let key in params) {
            if (!final.hasOwnProperty(key)) {
                final[key] = params[key];
            }
        }

        // Iterate over the final object assigning
        for (let key in final) _url.searchParams.append(key, final[key]);

        return _url.href;
    } catch (error) {
        // TODO: Use Microsoft App Centre error logging
        // eslint-disable-next-line no-console

        console.log("An error occurred while trying to create link for asset: ", error)
    }
}

// TODO: Secure should be true by default in production
export function asset(resource, secure = false) {
    try {
        // NOTE: If we are not in production, we should not be using the CDN
        if (Config.environment !== "production" || Config.cdnOverride === true) {
            return resource.charAt(0) === '/' ? resource : `/${resource}`;
        }

        // Remove trailing slashes
        if (resource.charAt(0) === '/') resource = resource.substr(1);

        // Create a new URL combining base and resource
        let url = new URL(Config.urls.cdnBaseUrl.concat(resource));

        // Check if secure when user wants secure
        if (secure && url.protocol === 'http:') url = new URL("https://".concat(url.host + url.pathname));

        return url.href;
    } catch (error) {
        // TODO: Use Microsoft App Centre error logging
        // eslint-disable-next-line no-console
        console.log("An error occurred while trying to create link for asset: ", error)
    }
}